import { PayoutError } from './payout-error';

export class TechnicalError extends PayoutError {}
